function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M23.937 21.522V2.392A2.394 2.394 0 0 0 21.545 0H2.415A2.394 2.394 0 0 0 .023 2.391v19.13a2.394 2.394 0 0 0 2.392 2.392h19.13a2.394 2.394 0 0 0 2.392-2.391zM6.24 22.957H2.415A1.437 1.437 0 0 1 .98 21.522V2.392C.98 1.6 1.624.956 2.415.956h2.391v14.347h1.435v7.653zm5.739 0H7.197v-7.653h1.435V.957h1.913v14.347h1.435v7.653zm5.74 0h-4.783v-7.653h1.434V.957h1.913v14.347h1.435v7.653zm.956-7.653h1.434V.957h1.435c.791 0 1.435.643 1.435 1.434v19.13c0 .792-.644 1.436-1.435 1.436h-2.87v-7.653z"
});

var SvgPiano = function SvgPiano(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPiano, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/piano.864b296a.svg";
export { ForwardRef as ReactComponent };